var map = {
	"./adult/de/readingtest-questions.json": 849,
	"./adult/nn/readingtest-questions.json": 850,
	"./adult/no/readingtest-questions.json": 851,
	"./youth/de/readingtest-questions.json": 852,
	"./youth/nn/readingtest-questions.json": 853,
	"./youth/no/readingtest-questions.json": 854,
	"./youth/se/readingtest-questions.json": 855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;